<template>
    <v-container>
        <v-card-title style="border-bottom: 1px solid rgba(255,0,0,0.2)" class="mb-4 pt-1 pb-1">
            <h2>Detalhes da chamada</h2>
        </v-card-title>
        <!-- LOADING CALL INFO -->
        <v-row v-if="loading" style="min-height: 200px;">
            <v-col style="display: flex; justify-content: center; align-items: center">
                <v-progress-circular
                        indeterminate
                        color="error"
                ></v-progress-circular>
            </v-col>
        </v-row>
        <!-- CALL INFOS -->
        <v-row v-else>
            <v-col>

                <!-- INFO CALL -->
                <v-container class="call-main-info">
                    <v-row>
                        <v-col cols="6" class="col-main-info" style="border-radius: 6px 0 0 0;">
                            <div class="outbound-call" v-if="selectedCall.src === '244575195' || selectedCall.src.length < 4">
                                <strong>Agente</strong>
                                <p class="pl-2 pt-1 mb-1">
                                    {{selectedCall.cnam}} - {{selectedCall.cnum}}
                                </p>
                            </div>
                            <div v-else class="inbound-call">
                                <strong>Cliente</strong>
                                <p class="pl-2 pt-1 mb-1" v-if="client && client.length > 0">
                                    {{client[0].Entidade}} - {{client[0].Nome}}
                                    <a :href="'/clients/clients/' + client[0].Entidade" target="_blank">
                                        <v-icon class="ml-1" size="20" color="info">mdi-open-in-new</v-icon>
                                    </a>
                                </p>
                                <p class="pl-2 pt-1 mb-1" v-else>
                                    Sem cliente associado ao contacto.
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="6" class="col-main-info" style="border-radius: 0 6px 0 0;">
                            <strong>Data/Hora</strong>
                            <p class="pl-2 pt-1 mb-1">
                                <v-icon color="warning" size="20" class="pr-1">mdi-calendar</v-icon>{{selectedCall.calldate}}
                                <v-spacer></v-spacer>
                                <v-chip
                                    color="red"
                                    x-small
                                    style="color: white"
                                    v-if="!checkDentroDoHorario(selectedCall.calldate)"
                                >
                                    FECHADO
                                </v-chip>
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="col-main-info">
                            <strong>Número</strong>
                            <p class="pl-2 pt-1 mb-1"><v-icon color="success" size="20" class="pr-1">mdi-phone</v-icon>{{selectedCall.src}}</p>
                        </v-col>
                        <v-col cols="6" class="col-main-info">
                            <strong>Estado</strong>
                            <div class="call-state" :class="[selectedCall.disposition === 'ANSWERED' ? 'call-answered' : (selectedCall.disposition === 'NO ANSWER' ? 'call-lost' : 'call-other-state')]">
                                <p class="pl-2 pt-1 mb-1">
                                    <v-icon v-if="selectedCall.disposition === 'ANSWERED'" size="20" class="pr-1" color="#008000FF">mdi-check-circle</v-icon>
                                    <v-icon v-else-if="selectedCall.disposition === 'NO ANSWER'" size="20" class="pr-1" color="#FF0000FF">mdi-alert-circle</v-icon>
                                    <v-icon v-else size="20" class="pr-1" color="#FFD700FF">mdi-help-circle</v-icon>
                                    {{selectedCall.disposition}}
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="col-main-info" style="border-radius: 0 0 0 6px;">
                            <strong>Destinatário</strong>
                            <p class="pl-2 mb-1">
                                <v-icon color="info" size="20" class="pr-1">mdi-phone</v-icon>
                                {{selectedCall.dst === '200' || selectedCall.dst === '8000' ? 'Atenção ao cliente' : selectedCall.dst}}
                            </p>
                        </v-col>
                        <v-col cols="6" class="col-main-info" style="border-radius: 0 0 6px 0;">
                            <div v-if="!checkDentroDoHorario(selectedCall.calldate)">
                                <p class="pl-2 pt-1 mb-1">FORA DE HORARIO DE SERVIÇO</p>
                            </div>
                            <div v-else-if="selectedCall.dst.length <= 4">
                                <strong>Agente</strong>
                                <p class="pl-2 pt-1 mb-1">{{selectedCall.extensao}}</p>
                            </div>
                            <div v-else>
                                <strong>Cliente</strong>
                                <p class="pl-2 pt-1 mb-1" v-if="client && client.length > 0">
                                    {{client[0].Entidade}} - {{client[0].Nome}}
                                    <a :href="'/clients/clients/' + client[0].Entidade" target="_blank">
                                        <v-icon class="ml-1" size="20" color="info">mdi-open-in-new</v-icon>
                                    </a>
                                </p>
                                <p class="pl-2 pt-1 mb-1" v-else>
                                    Sem cliente associado ao contacto.
                                </p>

                            </div>
                        </v-col>
                    </v-row>
                </v-container>

                <!-- OBSERVATIONS -->
                <v-container class="mt-2" style="padding: 12px 20px;">
                    <div class="mb-2" style="display: flex;justify-content: space-between; align-items: center">
                        <h3 class="mb-1">Interações</h3>
                        <v-btn v-if="(selectedCall.src.length > 4 || selectedCall.src === '244575195') && selectedCall.disposition === 'ANSWERED'" x-small color="success" @click="$emit('new-interaction-call')">
                            Adicionar<v-icon size="16" class="pl-1">mdi-plus</v-icon>
                        </v-btn>
                    </div>
                    <p v-if="callInteraction.length === 0" class="ml-4 mb-1">Sem interações registadas.</p>

                    <v-expansion-panels v-else accordion focusable>
                        <v-expansion-panel
                                v-for="(interaction,index) in callInteraction"
                                :key="index"
                        >
                            <v-expansion-panel-header class="interaction-call-panel-header">
                                <span class="pa-1 interaction-call-header">{{ interaction.id }}</span>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-2">
                                <v-row>
                                    <v-col cols="6">
                                        <h5>Agente</h5>
                                        <p class="pl-2 mb-0">{{interaction.agent_extension}} - {{interaction.agent}}</p>
                                    </v-col>
                                    <v-col cols="6">
                                        <h5>Cliente</h5>
                                        <p v-if="!interaction.final_client" class="pl-2 mb-0">
                                            {{interaction.entity}} - {{interaction.client}}
                                            <a :href="'/clients/clients/' + interaction.entity" target="_blank">
                                                <v-icon class="ml-1" size="14" color="info">mdi-open-in-new</v-icon>
                                            </a>
                                        </p>
                                        <div v-else>
                                            <span class="pa-1" style="background-color: #00C853;font-weight: bold;color: white;border-radius: 4px">CF</span>
                                            {{ interaction.client }}
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <h5>Observações</h5>
                                        <v-textarea readonly outlined hide-details v-model="interaction.observations"></v-textarea>
<!--                                        <p class="pl-2 mb-0">{{ interaction.observations }}</p>-->
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </v-container>

                <!--  LIST OF CALLS WITH THIS ID  -->
                <v-container v-if="callInfo != null" class="mt-2" style="padding: 12px 20px;">
                    <h4 class="pl-2">Chamadas associadas</h4>
                    <v-simple-table dense class="calls-associated-table">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>De</th>
                                <th>Para</th>
                                <th class="text-center">Duração</th>
                                <th class="text-center">Tempo Chamada</th>
                                <th class="text-center">Estado</th>
                                <th>DID</th>
                                <th class="text-center">Extensao</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="call-information-line" v-for="call in callInfo">
                                <td>{{call.calldate}}</td>
                                <td>{{call.src}}</td>
                                <td>{{call.dst}}</td>
                                <td class="text-center">{{call.duration}}</td>
                                <td class="text-center">{{call.billsec}}</td>
                                <td class="text-center">
<!--                                    {{call.disposition}}-->
                                    <div class="call-state" :class="[call.disposition === 'ANSWERED' ? 'call-answered' : (call.disposition === 'NO ANSWER' ? 'call-lost' : 'call-other-state')]">
                                        <p class="pl-2 pt-1 mb-1">
                                            <v-icon v-if="call.disposition === 'ANSWERED'" size="20" class="pr-1" color="#008000FF">mdi-check-circle</v-icon>
                                            <v-icon v-else-if="call.disposition === 'NO ANSWER'" size="20" class="pr-1" color="#FF0000FF">mdi-alert-circle</v-icon>
                                            <v-icon v-else size="20" class="pr-1" color="#FFD700FF">mdi-help-circle</v-icon>
                                            {{call.disposition}}
                                        </p>
                                    </div>
                                </td>
                                <td>{{call.did}}</td>
                                <td class="text-center">{{call.extensao}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
<!--                    <div class="call-information-line" v-for="call in callInfo">-->
<!--                        <v-row>-->
<!--                            <v-col>{{call.calldate}}</v-col>-->
<!--                            <v-col>{{call.src}}</v-col>-->
<!--                            <v-col>{{call.dst}}</v-col>-->
<!--                            <v-col>{{call.duration}}</v-col>-->
<!--                            <v-col>{{call.billsec}}</v-col>-->
<!--                            <v-col>{{call.disposition}}</v-col>-->
<!--                            <v-col>{{call.did}}</v-col>-->
<!--                        </v-row>-->
<!--                    </div>-->

                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import Issabel from "@/models/Issabel";

export default {
    props: {
        callID: String,
        call: Object,
    },
    data: () => ({
        loading: false,
        callInfo: null,
        callInteraction: null,
        selectedCall: {},
        client: null
    }),
    created() {
        this.getCallInfo();
    },
    methods: {
        getCallInfo(){
            this.loading = true;

            //Info to send on request
            let call = {
                call_id: this.callID
            }
            //Make request
            Issabel.dispatch('getCallInfo', call)
                    .then(response => {
                        let responseData = response.data;

                        this.callInfo = responseData.call;
                        this.callInteraction = responseData.interaction;

                        // this.filteredCall();

                        this.selectedCall = this.call;

                        // try match a client to the phone number
                        this.findClient();
                    })
                    .catch(response => {
                        console.log('ERROR: ' + response);
                        this.loading = false;
                    })
        },
        checkDentroDoHorario(data) {
            // Extrair a hora da string "2025-08-07 16:12:14"
            const horaString = data.split(' ')[1]; // "16:12:14"
            const [hora, minuto, segundo] = horaString.split(':').map(Number);

            const totalSegundos = hora * 3600 + minuto * 60 + segundo;

            // Definir intervalos válidos em segundos desde a meia-noite
            const inicioManha = 9 * 3600;     // 09:00:00
            const fimManha = 13 * 3600;       // 13:00:00
            const inicioTarde = 14 * 3600;    // 14:00:00
            const fimTarde = 18 * 3600;       // 18:00:00

            // Validar se está dentro de um dos dois intervalos
            return (
                    (totalSegundos >= inicioManha && totalSegundos < fimManha) ||
                    (totalSegundos >= inicioTarde && totalSegundos < fimTarde)
            );
        },
        findClient(){
            this.loading = true;
            let phoneNumber = '';

            //Chamada de cliente
            if (this.selectedCall.src !== '244575195' && this.selectedCall.src.length > 4){
                phoneNumber = this.selectedCall.src.replace(/\D/g, "").slice(-9);
                // console.log('de:' + phoneNumber)
            }
            //Chamada para cliente
            else if(this.selectedCall.src === '244575195') {
                phoneNumber = this.selectedCall.dst.replace(/\D/g, "").slice(-9);
                // console.log('para: ' + phoneNumber)
            }

            Issabel.dispatch('getClient', phoneNumber)
                    .then(response => {
                        let responseData = response.data;
                        this.client = responseData;

                        this.loading = false;
                    })
                    .catch(response =>{
                        console.log('ERROR: ' + response);
                        this.loading = false;
                    })

        }
    }
}

</script>
<style scoped>
.call-main-info {
    padding: 12px 28px;

    .col-main-info{
        border: 1px solid rgba(0, 0, 0, 0.4);
    }
}

.call-state{
    width: 120px;
    border: 1px solid rgba(0,0,0,0.08);
    border-radius: 12px;
    display: flex;
    justify-content: center;
}
.call-answered{
    background-color: rgba(0,128,0,0.08);
    color: green;
    font-size: 12px;
}
.call-lost{
    background-color: rgba(255,0,0,0.08);
    color: red;
    font-size: 12px;
}
.call-other-state{
    background-color: rgba(255,215,0,0.08);
    color: gold;
    font-size: 12px;
}

.calls-associated-table{
    border: 1px solid rgba(0, 0, 0, 0.4);
}
.interaction-call-panel-header {
    min-height: 35px;
    max-height: 35px;
    padding-top: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid cadetblue;

    .interaction-call-header {
        background-color: rgba(0, 0, 0, 0.08);
        max-width: 40px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.4);
        font-size: 12px;
        font-weight: bold;
    }
}
</style>